import { useText } from "../lib/siteText";

export default function About() {
  const t = useText();
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="overline-label mb-3">{t("about_overline")}</div>
      <h1 className="font-serif text-5xl lg:text-7xl font-light" data-testid="about-title">{t("about_title")}</h1>
      <div className="mt-10 space-y-6 text-neutral-300 leading-relaxed text-lg font-light whitespace-pre-line">
        <p data-testid="about-p1">{t("about_p1")}</p>
        <p>{t("about_p2")}</p>
        <p>{t("about_p3")}</p>
      </div>
      <div className="mt-14 grid grid-cols-3 gap-6 border-t border-white/10 pt-10">
        {[["Weddings captured", "2,000+"], ["Years behind the lens", "20"], ["Published in", "SI · ESPN"]].map(([l, v]) => (
          <div key={l}>
            <div className="font-serif text-4xl text-amber-glow">{v}</div>
            <div className="overline-label mt-1">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
